import type { EmbedPublicData } from './resolve-embed';

export function mountUi(embed: EmbedPublicData): void {
  if (embed.show_ai_modes) {
    const badge = document.createElement('div');
    badge.className = 'ai-badge';
    badge.textContent = 'AI-bewerkt';
    badge.setAttribute('title', 'Deze versie bevat AI-gegenereerde aanpassingen (AI Act art. 50)');
    document.body.appendChild(badge);
  }

  const controls = document.createElement('div');
  controls.className = 'controls';
  controls.innerHTML = `
    <button data-action="reset" aria-label="Reset weergave">↺ Reset</button>
    <button data-action="fullscreen" aria-label="Volledig scherm">⤢ Vol</button>
    <button data-action="measure" aria-label="Meten">📏 Meet</button>
    ${embed.assets.plan_url ? '<button data-action="plan" aria-label="Plattegrond">🗺️ Plan</button>' : ''}
  `;
  document.body.appendChild(controls);

  controls.addEventListener('click', (ev) => {
    const target = ev.target as HTMLButtonElement;
    const action = target.dataset.action;
    if (action === 'fullscreen') {
      void document.documentElement.requestFullscreen().catch(() => undefined);
    }
    // overige acties: dispatch via custom events naar main.ts
    document.dispatchEvent(new CustomEvent('hs-viewer-action', { detail: { action } }));
  });
}
